import React, { createContext, useContext, useEffect, useState } from "react";
import { useNavigation } from "react-router-dom";

interface NavigationContextValue {
  isNavigating: boolean;
}

const NavigationContext = createContext<NavigationContextValue | null>(null);

export const NavigationProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const navigation = useNavigation();
  const [isNavigating, setIsNavigating] = useState(false);

  useEffect(() => {
    if (navigation.state === "loading") {
      const timeout = setTimeout(() => setIsNavigating(true), 200);
      return () => clearTimeout(timeout);
    }

    setIsNavigating(false);
  }, [navigation.state]);

  return (
    <NavigationContext.Provider value={{ isNavigating }}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigationContext = (): NavigationContextValue => {
  const context = useContext(NavigationContext);

  if (!context)
    throw new Error(
      "useNavigationContext must be used within a NavigationProvider",
    );

  return context;
};
